import { createSelector, createFeatureSelector } from '@ngrx/store';

const state = createFeatureSelector<OLO.State, OLO.State.Loader>('loader');

export const isLoaderVisible = createSelector(state, (loader) => loader.isVisible);
